import React from 'react';
import { useTranslation } from 'react-i18next';

const AdvancedSearchPage = ({ isOpen, onClose }) => {
        const { t } = useTranslation();
    
    if (!isOpen) return null;

        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center">
                {/* Backdrop */}
                <div
                    className="fixed inset-0 bg-black bg-opacity-50"
                    onClick={onClose}
                />

                {/* Modal Content */}
                <div className="relative bg-white w-[80%] h-[80%] max-w-[50%] max-h-[80%] overflow-y-auto rounded-lg p-6 z-10">
                    {/* Close Button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    {/* Contact Section */}
                     <div className="text-left bg-white text-black p-8 rounded-lg">
      <h1 className="text-2xl font-semibold mb-4">{t('complexSearch.title')}</h1>

      <b>{t('complexSearch.subtitle')}</b>
      <p>{t('complexSearch.intro')}</p>

      <ul>
        <li><b>{t('complexSearch.examples.example1.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example1.description')}</p>

        <li><b>{t('complexSearch.examples.example2.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example2.description')}</p>

        <li><b>{t('complexSearch.examples.example3.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example3.description')}</p>

        <li><b>{t('complexSearch.examples.example4.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example4.description')}</p>

        <li><b>{t('complexSearch.examples.example5.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example5.description')}</p>

        <li><b>{t('complexSearch.examples.example6.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('complexSearch.examples.example6.description')}</p>
      </ul>

      <br />
      <b>{t('fields.title')}</b>
      <table style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black', padding: '10px' }}>
        <thead>
          <tr>
            <th>{t('fields.headers.name')}</th>
            <th>{t('fields.headers.type')}</th>
            <th>{t('fields.headers.description')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('fields.rows.title.name')}</td>
            <td>{t('fields.rows.title.type')}</td>
            <td>{t('fields.rows.title.description')}</td>
          </tr>
          <tr>
            <td>{t('fields.rows.summary.name')}</td>
            <td>{t('fields.rows.summary.type')}</td>
            <td>{t('fields.rows.summary.description')}</td>
          </tr>
          <tr>
            <td>{t('fields.rows.authors.name')}</td>
            <td>{t('fields.rows.authors.type')}</td>
            <td>{t('fields.rows.authors.description')}</td>
          </tr>
          <tr>
            <td>{t('fields.rows.year.name')}</td>
            <td>{t('fields.rows.year.type')}</td>
            <td>{t('fields.rows.year.description')}</td>
          </tr>
          <tr>
            <td>{t('fields.rows.journal.name')}</td>
            <td>{t('fields.rows.journal.type')}</td>
            <td>{t('fields.rows.journal.description')}</td>
          </tr>
        </tbody>
      </table>

      <br />
      <b>{t('charSearch.title')}</b>

      <h2>{t('charSearch.star.title')}</h2>
      <p>{t('charSearch.star.description')}</p>
      <ul>
        <li><b>{t('charSearch.star.examples.example1.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('charSearch.star.examples.example1.description')}</p>

        <li><b>{t('charSearch.star.examples.example2.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('charSearch.star.examples.example2.description')}</p>
      </ul>

      <hr />
      <h2>{t('charSearch.question.title')}</h2>
      <p>{t('charSearch.question.description')}</p>
      <ul>
        <li><b>{t('charSearch.question.examples.example1.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('charSearch.question.examples.example1.description')}</p>
      </ul>

      <hr />
      <h2>{t('proximitySearch.title')}</h2>
      <p>{t('proximitySearch.description')}</p>
      <ul>
        <li><b>{t('proximitySearch.examples.example1.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('proximitySearch.examples.example1.description')}</p>
      </ul>

      <hr />
      <h2>{t('fuzzySearch.title')}</h2>
      <p>{t('fuzzySearch.description')}</p>
      <ul>
        <li><b>{t('fuzzySearch.examples.example1.query')}</b></li>
        <p style={{ paddingLeft: '20px' }}>{t('fuzzySearch.examples.example1.description')}</p>
      </ul>
    </div>
                </div>
            </div>
        );

};

export default AdvancedSearchPage;
